const template = `
    <div data-notify="container" class="col-xs-33 col-sm-18 col-md-12 col-lg-9 alert alert-{0}" role="alert">
        <button type="button" aria-hidden="true" class="close" data-notify="dismiss">×</button>
        <span data-notify="icon"></span>
        <h4>{1}</h4>
        <span data-notify="message" class="notifier-message-text">{2}</span>
        <div class="progress" data-notify="progressbar">
		    <div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" 
                 aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>
	    </div>
	    <a href="{3}" target="{4}" data-notify="url"></a>
    </div>
`;

$.notifyDefaults({
    offset: 50,
    mouse_over: "pause",
    placement: {
        from: "top",
        align: "center"
    },
    template: template,
    z_index: 11000
});